

export const StringHelpers = {

  /**
   * Turns CK5Editor "empty" strings into null, otherwise, returns the
   * src string
   *
   * @param src
   */
  safeHTML(src:string) {
    if(src) {
      const trimmedSrc = src.trim();
      if(trimmedSrc.length!=0 && trimmedSrc!=='<p>&nbsp;</p>' && trimmedSrc!=='<p><br></p>') {
        return trimmedSrc;
      }
    }
    return null;
  }

}
